module.exports = __webpack_public_path__ + "img/icon-eth-blue.638adc76.svg";